import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {  CotisationControllerService, PartnerCtlService, ReceiptControllerService } from '../api/services';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularDeviceInformationService } from 'angular-device-information';
import { PartnerDto, PaymentResponseDto } from '../api/models';

import { QRCodeComponent } from 'angularx-qrcode';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-cotisation',
  imports: [
    ReactiveFormsModule,
    QRCodeComponent
],
  templateUrl: './cotisation.component.html',
  styleUrl: './cotisation.component.css'
})
export class CotisationComponent implements OnInit {

  message ='';
    paymentNetwork='';
    fees =0;
    isWallet=false;
    isBill=true;
    isPayment =false;
   
    amount?:number;
    qrCode='';
    
    formCotisation:FormGroup;
    associations?:Array<PartnerDto>;
    paymentNetworkOtpion='';
    assoc?:PartnerDto;
    idAssoc?:number;
    isQrCode=false;

   constructor(private formBuilder:FormBuilder,
    private cotisationService:CotisationControllerService,  
    private partnerService:PartnerCtlService,
      private receiptService:ReceiptControllerService,
      private activeRoute:ActivatedRoute,
      private route:Router,
      private deviceInfo:AngularDeviceInformationService
    ){
  
      this.formCotisation = this.formBuilder.group({
        idPartner:[Validators.required],
        amount:['',Validators.required],
        phone:[''],
        paymentNetwork:['',Validators.required],
        paymentMethod:['',Validators.required],
        payNetworkOption:[''],
      });
    }
    ngOnInit(): void {
      this.activeRoute.queryParams.subscribe(p=>{
        this.idAssoc=p['idAssoc'];
      })
  
      if(this.idAssoc== undefined){
        this.loadAssociations();

      }else{
        this.isQrCode=true;
      this.loadAssociationInfo(this.idAssoc);
      this.formCotisation.controls['idPartner'].setValue(this.idAssoc);
    }
    }
    loadAssociationInfo(idAssoc:number){

      this.partnerService.getPartnerDetails1(
        idAssoc!!    
    ).subscribe(
        {
          next:(resp)=>{
            this.assoc=resp;
           
          }
        }
      );
    }
    loadAssociations(){

      this.partnerService.getPartnerByMcc(
         '8398'
        
      ).subscribe(
        {
          next:(resp)=>{
            this.associations=resp;
            this.isQrCode=false;
            
          }
        }
      );
    }
    createPayment(){
      let form = this.formCotisation.value;
      this.cotisationService.createCotisation(
           form
          ).subscribe(
            {
              next:(resp)=>{
                if(resp.status =='PENDING'){
                  if(this.paymentNetwork.toUpperCase() == 'OMSN'){
                    this.handleOrangemoneyResponse(resp);
                  }else{
                    if(resp.paymentUrl){
                      this.openUrl(resp.paymentUrl);
                    }
                  }
                
              }
      
              },
              error:(err)=>{
                this.message =err.error.message;
                const elt =document.getElementById('modErrPay');
                                 const modAdd = new bootstrap.Modal(elt!!);
                                 modAdd.show();
              }
            }
          );
    }
    
    isValid(){}
    completeForm(paymentNetwork:string){

     
      this.formCotisation.controls['paymentNetwork'].setValue(paymentNetwork);
      this.paymentNetwork = paymentNetwork.toUpperCase();
      const methods = document.querySelectorAll('.payment-method');
  
      if(this.paymentNetwork === 'CARD'){
        this.isWallet = false;
        this.formCotisation.controls['paymentMethod'].setValue('CARD');
     
      }else {
        console.log('is wallet');
        this.isWallet =true;
        this.formCotisation.controls['paymentMethod'].setValue('WALLET');
        
        if(this.paymentNetwork=='OMSN'){
        this.formCotisation.controls['payNetworkOption'].setValue('maxit');
      }
     
  
      }
  
      methods.forEach(element => {
        
        console.log(element.getAttribute('data-method'));
        console.log(paymentNetwork);
        if(element.getAttribute('data-method') == paymentNetwork.toLowerCase()){
          element.classList.add('active');
  
        }else {
          element.classList.remove('active');
        }
        
      });
  
    }

     onSelectPaymentMethod(paymentMethod:string){
        
      console.log(paymentMethod);
       this.completeForm(paymentMethod);
    
      }
      handleOrangemoneyResponse(resp:PaymentResponseDto){
            console.log('orange money');
            if(resp.status =='PENDING'){
              if(this.deviceInfo.isMobile()){
                if(resp.paymentUrl){
                this.openUrl(resp.paymentUrl);
                }
              }else {
                this.qrCode =resp.qrCode!!;
                console.log(this.qrCode);
                this.isPayment =false;
                this.finalizePayment(resp.reference!!);
                
              }
            }
        
          }
          async finalizePayment(reference:string){
            
            this.receiptService.getPaymentDetails(
              reference
            ).subscribe({
              next:(resp)=>{
                console.log(resp);
                if(resp.status =='PENDING'){
                  setTimeout(()=>
                    {
                      this.finalizePayment(reference);
                    },
                    15000);
                }else {
                  this.route.navigateByUrl('receipt?reference='+reference);
                  
                }
                
              },
              
            });
           
          }
          openUrl(url:string){
        
             window.open(url,'_self');
          }
          checkBeginForm(){
            let form = this.formCotisation.value;
            let idPartner =form.idPartner;
            let amount =form.amount;
            console.log(idPartner);
            console.log(amount);
            if((idPartner>0||this.idAssoc!!>0)&&amount>0){
              this.isPayment=true;
              this.isWallet =false;
            }else{
              this.isPayment=false;
              this.formCotisation.controls['paymentMethod'].setValue('');
              this.formCotisation.controls['payNetworkOption'].setValue('');
              this.isWallet=false;
           
            }
          }
}
